import { INTEGRATIONS_UI_CONFIG } from "./config/integrations.config";

const CHANNEL_KEYS = new Set(["whatsapp", "messenger", "instagram"]);

export const ChannelAvatarBadge = ({ channel }: { channel?: string | null }) => {
  const normalized = String(channel || "whatsapp").toLowerCase();
  if (!CHANNEL_KEYS.has(normalized)) return null;

  const config = INTEGRATIONS_UI_CONFIG[normalized as keyof typeof INTEGRATIONS_UI_CONFIG];
  const label =
    normalized === "whatsapp"
      ? "WhatsApp"
      : normalized === "messenger"
        ? "Messenger"
        : "Instagram";

  return (
    <span
      className="absolute -bottom-0.5 -left-0.5 flex size-4 items-center justify-center overflow-hidden rounded-full bg-white ring-1 ring-gray-200"
      title={label}
      aria-label={label}
    >
      <img
        src={config.logoSrc}
        alt=""
        className="size-2.5 object-contain opacity-60 grayscale"
      />
    </span>
  );
};
